const zh = {
  // 导航栏
  home: '首页',
  businessCop: '商务合作',
  companyName: '先问',
  productService: '产品服务',
  modao: '墨刀',
  mohe: '墨盒',
  aboutus: '关于我们',
  solution: '解决方案',
  introduceCom: '公司介绍',
  joinUs: '加入我们',
  allTitle: 'Xianwen 先问-多行业领域科技赋能整体方案提供商',

  // 底部
  customizationSolution: '定制化风控解决方案',
  intelligentDecision: '智能决策引擎',
  productIntroduce: '产品介绍',
  modaoSolution: '墨刀一站式现金贷解决方案',
  moheSolution: '墨盒-全自动AI风控解决方案',
  applyUse: '申请试用',

  //home
  bannerTitle: '多行业领域科技赋能整体方案提供商',
  bannerTip1: '先问科技专注于打造电商、金融科技、软件服务等多行业领域的成就技术解决方案',
  bannerTip2: '为您提供定制化开发服务和标准行业产品，帮助合作商快速实现智能化转型，提升商业价值和行业竞争力',

  productDes: '先问为合作伙伴提供高效、专业的技术解决方案和优质的产品服务<br>让你的表现与众不同，让成功触手可得',

  eshop: '电商平台',
  eshopDetail1: '跨境电商平台',
  eshopDetail2: '社区O2O平台',
  eshopDetail3: '消费电商平台',
  eshopDetail4: '母婴电商平台',

  fintech: '金融科技',
  fintechDetail1: '现金贷平台系统',
  fintechDetail2: '反欺诈风控系统',
  fintechDetail3: '贷款超市系统',
  fintechDetail4: '智能外呼系统',

  saas: '企业软件',
  saasDetail1: 'CRM管理平台',
  saasDetail2: 'OA管理平台',

  thingsnet: '物联网',
  thingsnetDetail1: 'ThinkHome智能家居',
  thingsnetDetail2: 'ThinkHome智能办公',

  serviceDes: '无论是定制化开发还是标准化产品我们都能提供给您最好的服务,<br>帮助您更好的专注于业务和提升效率',

  customizonDev: '定制化开发',
  customizonTip1: '高效的研发团队',
  customizonTip2: '专业的需求团队',

  standardProduct: '标准行业产品',
  standardProductTip1: '极具口碑的产品',
  standardProductTip2: '全流程的解决方案',

  extraDomain: '可扩展领域研发',
  extraDomainTip1: '不断探索新的领域',
  extraDomainTip2: '接受新行业的挑战',

  outfootprint:  '我们的足迹',
  singapore: '新加坡',
  singaporeAddress: '8 Marina Boulevard #14-03A<br>Marina Bay Financial Centre Tower 1',
  china: '中国',
  chinaAddress: '杭州市余杭区贝达梦工厂D座',
  india: '印度',
  indiaAddress: 'Site no # 9, 1st C Main Road, Jakkasandra Extension, 1st Block Koramangala, Bengaluru, Karnataka 560034',
  indonesia: '印度尼西亚',
  indonesiaAddress: 'Jl. Boulevard Timur, RT.1/RW.12, Pegangsaan Dua, Kec. Klp. Gading, Kota Jkt Utara, Daerah Khusus Ibukota Jakarta 14250, Indonesia',

  partner: '合作伙伴',

  //商务 合作
  contactUs: '联系我们',
  name: '姓名',
  phone: '电话',
  email: '邮箱',
  requirement: '您的需求',
  submit: '提交',

  //解决方案
  solutionTitle: '电商解决方案',
  solutionDes: '企业级电商平台提供商，为企业级商家提供电商平台搭建及解决方案服务',

  eshopPlatform: '跨境电商平台',
  o2oPlatform: '社区O2O平台',
  consumePlatform: '消费电商平台',
  momPlatform: '母婴电商平台',

  eshopPlatformDesc: '解决商品、商家、海关和边检系统备案，订单跨境支付和一键报关等方案',
  o2oPlatformDesc: '针对社区行业，提供多销售终端，提高线上线下联动业务经营，打造互联网+社区电商系统生态链',
  consumePlatformDesc: '针对以加盟、直营、零售等形式的连锁便利店、门店、百货店及其它零售形态',
  momPlatformDesc: '基于母婴行业特点，打通线上和线下渠道，搭建一个完善的全网营销系统',

  knowMore: '了解更多',
  advantage: '我们的优势',

  fintechTitle: '金融科技解决方案',
  fintechDesc: '探索Fintech领域的星辰大海',
  modaoDesc: '海外现金贷一站式解决方案',
  modaoDetail: '提供海外Fintech一站式产品与技术服务、完美解决 业务落地、系统搭建、运营模式输出',
  moheDesc: '海外大数据风控系统',
  moheDetail: '大数据+AI 技术结合的智能风控解决方案',

  saasDesc: '企业软件开发',

  thingsDesc: '物联网解决方案',
  thinkHome: 'ThinkHome智能家居 (研发中)',
  thinkHomeDetail: '全屋智能化一站式服务我们懂您所想， 让你真正享受温馨舒适的生活环境。',
  thinkoffice: 'ThinkOffice智能办公 (研发中)',
  thinkofficeDetail: '公司管理智能化服务，助力提高办公效率和 办公质量，改善办公条件，实现管理可视化 和科学化。',

  //mohe
  overseasMohe: '海外全自动大数据风控系统',
  dataDes: '基于海量数据源',
  dataNumber1: '海外借款用户数据',
  dataNumber2: '海外借款用户行为数据',
  dataNumber3: '海外用户身份数据',

  sixAdvantage: '6大核心优势',
  advantageBlacklist: '多数据源黑名单撞库， 直接拒绝海外借贷黑户',
  advantageReview: '全自动审核流程， 无需人工介入， 减少运营和管理成本',
  advantageResult: '1分钟内审核出结果， 减少用户等待时间， 提高产品体验，快速起量',
  advantageChidu: '可调整风控审核尺度， 根据运营成本合理配置',
  advantageOverdue: '可追溯渠道查看逾期表现、 合理运营',
  advantageLead: '领先于行业的首逾 和在逾表现',

  beginService: '现在加入我们开始服务吧！',
  experienceNow: '立即体验',


  //modao
  difficultDesc: '先问为合作伙伴提供高效、专业的技术解决方案和优质的产品服务<br>让你的表现与众不同，让成功触手可得',

  settleDifficult: '落户困难',
  settle1: '如何搞定牌照?',
  settle2: '如何招聘管理?',
  settle3: '如何进出资金?',

  techDifficult: '技术困难',
  tech1: '如何搭建全流程系统？',
  tech2: '如何搞定应用市场？',
  tech3: '如何制定风控流程？',

  runDifficulr: '运营困难',
  run1: '如何搞定流量推广？',
  run2: '如何管理催熟团队？',
  run3: '如何算清海外账务？',

  serviceAdvantage: '服务优势',
  serviceDesc: '墨刀的优势就是为您提供一站式海外现金贷服务，从行业干货分享、牌照租借或申请、企业落地招聘管理 、系统全流程搭建、接入全自动化风控、应用上架、流量推广、催收培 训到最后到海关账务清算，您能想到的和想不到的墨刀都做了',

  fastSettle: '快速落地',
  fastSettleDes1: '搞定牌照租借、申请、资金进出',
  fastSettleDes2: '企业组册、海外控股、初始化招聘',

  systemMakeup: '全流程系统搭建',
  systemMakeupDes1: '客户端产品、产品官网、运营管理平台一周上线',
  systemMakeupDes2: 'GoogPlay应用上架、全自动风控接入',

  planOutput: '运营方案全输出',
  planOutputDes1: '多平台流量获客方案输出一个月起量',
  planOutputDes2: '催收 搭建、培训、管理',

  dataSafety: '数据安全可靠',
  dataSafetyDes1: '独立云服务、云数据防止数据泄露',
  dataSafetyDes2: '独立产品、独立平台运营、风险远远低于saas模式',


  //joinus
  togetherWork: '一起做事，一起长大<br>我们需要你的加入',
  techType: '技术类',
  backendType: '后端工程师',
  androidType: 'Android工程师',
  dataType: '数据类',
  productType: '产品类',
  otherType: '其他职位',
  resumeEmail: '简历请投递至shermaine@Xianwen.sg',

  //introduce
  introduceOne: '先问科技，行业内领先的科技公司，致力于通过信息技术、大数据AI技术 为合作伙伴提供顶尖技术服务。未来，先问科技将在多元化的互联网行业中，寻找更多的合作伙伴，引领多行业领域的用户体验革命，更好的改变人们的生活。',
  introduceTwo: '团队成员拥有BAT、华为等国内外知名IT及互联网企业工作经历，在技术研发、数据建模、算法分析、人工智能、金融服务、项目管理、产品运营等领域具有丰富的开发管理经验与优势。既具有广阔的视野、全球性的思维模式，又深度理解本土化、地域性需求。',
  introduceThree: '这里有一大群充满热情、才华横溢、谦虚谨慎、好玩有趣的人，快来加入我们吧！',

  ourTeam: '我们的团队',
  ourCulture: '公司文化',

}

export default zh;


// WEBPACK FOOTER //
// ./src/locale/config/zh.js